import {
  ActionType,
  IUpdateClassData,
} from "../../../models/classmanagement/updateClass";
import { IResponse } from "models";

export const updateClassAction = (payload: IUpdateClassData) => {
  return {
    type: ActionType.UPDATE_CLASS,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.UPDATE_CLASS_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IResponse) => {
  return {
    type: ActionType.UPDATE_CLASS_SUCCESS,
    payload,
  };
};
